import { getRouterSelectors } from '@ngrx/router-store';

export const { selectCurrentRoute, selectFragment, selectQueryParams, selectRouteParams, selectRouteData, selectUrl } =
  getRouterSelectors();
